import { DateG6k } from "../date/date-g6k";
import { TYPE as T} from "./token-types";
export class Token {

    constructor(type, value) {
        this.type = type;
        this.arity = 0;
        this.value = value;
        this.types = T;
    }

    static get TYPE () {
        return T;
    }

    isUnaryOperator () {
        switch (this.type) {
            case Token.TYPE.T_NOT:
            case Token.TYPE.T_UNARY_PLUS:
            case Token.TYPE.T_UNARY_MINUS:
            case Token.TYPE.T_TERNARY_ELSE:
            case Token.TYPE.T_DEGRE:
                return true;
        }
        return false;
    }

    isBinaryOperator () {
        switch (this.type) {
            case Token.TYPE.T_POW:
            case Token.TYPE.T_TIMES:
            case Token.TYPE.T_DIV:
            case Token.TYPE.T_MOD:
            case Token.TYPE.T_PLUS:
            case Token.TYPE.T_MINUS:
            case Token.TYPE.T_BITWISE_AND:
            case Token.TYPE.T_BITWISE_OR:
            case Token.TYPE.T_BITWISE_XOR:
            case Token.TYPE.T_LOGICAL_AND:
            case Token.TYPE.T_LOGICAL_OR:
                return true;
        }
        return false;
    }

    isTernaryOperator () {
        switch (this.type) {
            case Token.TYPE.T_TERNARY:
                return true;
        }
        return false;
    }

    isOperator () {
        return this.isUnaryOperator()
            || this.isBinaryOperator()
            || this.isTernaryOperator();
    }

    isComparator () {
        switch (this.type) {
            case Token.TYPE.T_EQUAL:
            case Token.TYPE.T_NOT_EQUAL:
            case Token.TYPE.T_LESS_THAN:
            case Token.TYPE.T_LESS_OR_EQUAL:
            case Token.TYPE.T_GREATER_THAN:
            case Token.TYPE.T_GREATER_OR_EQUAL:
            case Token.TYPE.T_CONTAINS:
            case Token.TYPE.T_NOT_CONTAINS:
                return true;
        }
        return false;
    }

    isVariable () {
        switch (this.type) {
            case Token.TYPE.T_IDENT:
            case Token.TYPE.T_FIELD:
            case Token.TYPE.T_UNDEFINED:
                return true;
        }
        return false;
    }

    isUndefined () {
        return this.type == Token.TYPE.T_UNDEFINED;
    }

    isBeforeFunctionArgument () {
        switch (this.type) {
            case Token.TYPE.T_POPEN:
            case Token.TYPE.T_COMMA:
            case Token.TYPE.T_NOOP:
                return true;
        }
        return false;
    }

    precedence () {
        switch (this.type) {
            case Token.TYPE.T_POPEN:
            case Token.TYPE.T_PCLOSE:
            case Token.TYPE.T_POW:
                return 1;
            case Token.TYPE.T_NOT:
            case Token.TYPE.T_UNARY_PLUS:
            case Token.TYPE.T_UNARY_MINUS:
            case Token.TYPE.T_DEGRE:
                return 2;
            case Token.TYPE.T_TIMES:
            case Token.TYPE.T_DIV:
            case Token.TYPE.T_MOD:
                return 3;
            case Token.TYPE.T_PLUS:
            case Token.TYPE.T_MINUS:
                return 4;
            case Token.TYPE.T_LESS_THAN:
            case Token.TYPE.T_LESS_OR_EQUAL:
            case Token.TYPE.T_GREATER_THAN:
            case Token.TYPE.T_GREATER_OR_EQUAL:
                return 6;
            case Token.TYPE.T_EQUAL:
            case Token.TYPE.T_NOT_EQUAL:
            case Token.TYPE.T_CONTAINS:
            case Token.TYPE.T_NOT_CONTAINS:
                return 7;
            case Token.TYPE.T_BITWISE_AND:
                return 8;
            case Token.TYPE.T_BITWISE_XOR:
                return 9;
            case Token.TYPE.T_BITWISE_OR:
                return 10;
            case Token.TYPE.T_LOGICAL_AND:
                return 11;
            case Token.TYPE.T_LOGICAL_OR:
                return 12;
            case Token.TYPE.T_TERNARY_ELSE:
                return 13;
            case Token.TYPE.T_TERNARY:
                return 14;
            case Token.TYPE.T_COMMA:
                return 15;
        }
        return 16;
    }

    associativity () {
        switch (this.type) {
            case Token.TYPE.T_POW:
            case Token.TYPE.T_NOT:
            case Token.TYPE.T_UNARY_PLUS:
            case Token.TYPE.T_UNARY_MINUS:
                return Token.TYPE.A_RIGHT;
            case Token.TYPE.T_DEGRE:
            case Token.TYPE.T_TIMES:
            case Token.TYPE.T_DIV:
            case Token.TYPE.T_MOD:
            case Token.TYPE.T_PLUS:
            case Token.TYPE.T_MINUS:
            case Token.TYPE.T_LESS_THAN:
            case Token.TYPE.T_LESS_OR_EQUAL:
            case Token.TYPE.T_GREATER_THAN:
            case Token.TYPE.T_GREATER_OR_EQUAL:
            case Token.TYPE.T_EQUAL:
            case Token.TYPE.T_NOT_EQUAL:
            case Token.TYPE.T_CONTAINS:
            case Token.TYPE.T_NOT_CONTAINS:
            case Token.TYPE.T_BITWISE_AND:
            case Token.TYPE.T_BITWISE_XOR:
            case Token.TYPE.T_BITWISE_OR:
            case Token.TYPE.T_LOGICAL_AND:
            case Token.TYPE.T_LOGICAL_OR:
            case Token.TYPE.T_TERNARY:
                return Token.TYPE.A_LEFT;
            case Token.TYPE.T_TERNARY_ELSE:
                return Token.TYPE.A_RIGHT;
            case Token.TYPE.T_COMMA:
                return Token.TYPE.A_LEFT;
        }
        return Token.TYPE.A_NONE;
    }

    toString () {
        switch (this.type) {
            case Token.TYPE.T_DATE:
                return this.value.format(DateG6k.format);
                break;
            case Token.TYPE.T_BOOLEAN:
                return this.value ? 'true' : 'false';
                break;
            case Token.TYPE.T_FUNCTION:
                return this.value;
                break;
            case Token.TYPE.T_ARRAY:
                return JSON.stringify(this.value);
                break;
            default:
                return this.value.toString();
        }
    }

}
